export const GET_USERNAME = "/admin/:username";
export const FetchSaleDataForBill = "client_payments/getSaleObjectsForBill";
export const CompletePayout = "client_payments/payoutCompleted";
export const FetchSubdomainClients = "/subdomain_clients/fetchSubdomainClients";
export const CreateSubdomainClient = "/subdomain_clients/createSubdomainClient";
export const UpdateSubdomainClient = "/subdomain_clients/updateSubdomainClient";
export const FetchAllSubscriptionPlans = "/subscription_plans/fetchAllPlans";
export const UpdateSubscriptionPlans = "/subscription_plans/updatePlan";
export const FetchTransactionsList = "client_payments/getPendingSettlements";
export const SettleTransactions = "client_payments/settle";
export const GetGrowezyClientList = "/admin/getClientList";
export const GetGrowezyClientMetrics = "/admin/getClientMetrics";
export const GetGrowezyClientOnboardingMetrics = "/admin/getOnboardingMetrics";
export const GetGrowezyClientSettlementDetails = "/admin/getSettlementDetails";
export const GetGroupedSettlementDetails = "/admin/getGroupedSettlementDetails";
export const GetTdsDetails = "/admin/getTdsDetails";
export const GetGrowezyClientPayoutSummaryDetails = "/admin/getPayoutsSummary";
export const GetSettlementDetail = "/admin/getSettlementDetails/:settlementId";
export const GetOrders = "admin/getOrders";
export const Settle = "/admin/settle";
export const EngageClients = "/admin/engageClients";
export const SuperAdminLogin = "/superAdminLogin";

// Category Pages (super-admin)
export const CategoryPagesList = "/category-pages";
export const CategoryPageDetail = "/category-pages/:id";
export const CategoryPageBrandPagesFilter = "/category-pages/brand-pages";
export const CategoryPageOfferingsSearch = "/category-pages/offerings/search";
export const CategoryPageEvents = "/category-pages/:id/events";
export const CategoryPageEventBySlug = "/category-pages/:id/events/:slugId";
export const CategoryPageEventsReorder = "/category-pages/:id/events/reorder";
export const CategoryPageStatsRefresh = "/category-pages/:id/stats/refresh";

export const GetHelpVideos = "/help/getHelpVideos/:id";
export const AddNewHelpVideo = "/help/uploadNewHelpVideo";
export const UpdateHelpVideo = "/help/updateHelpVideo";
export const DeleteHelpVideo = "/help/deleteHelpVideo/:tag/:id";

export const SendSettlementCommunication = "/admin/sendSettlementCommunication";
export const SendSettlementCommunicationForASettlementId =
  "/admin/sendSettlementCommunication/:settlementId";
export const ManuallyDoReadyToProcess = "admin/manuallyDoReadyToProcess";
export const InstaClientsApi = "admin/instaClients";
export const GetAllGrowezyClients = "/admin/clients/all";
export const GetDashboardMetrics = "/admin/dashboard/metrics";
export const GetClientDetails = "/admin/client/:userId/details";
export const UpdateClientKycCommission = "/admin/client/:userId/kyc-commission";
export const AdminValidateBank = "/cashfree-payouts/admin/validate-bank";
export const AdminVerifyUserBank = "/cashfree-payouts/admin/verify-user-bank";
export const VerifyBeneficiary = "/admin/settle/verify-beneficiary";
export const SettleBulk = "/admin/settle/bulk";

// Platform Analytics
export const PlatformAnalyticsOverview = "/platformAnalytics/overview";
export const PlatformAnalyticsRevenueChart = "/platformAnalytics/revenue/chart";
export const PlatformAnalyticsCreatorFunnel = "/platformAnalytics/creator-funnel";
export const PlatformAnalyticsCreatorFunnelDrilldown = "/platformAnalytics/creator-funnel/drilldown";
export const PlatformAnalyticsTopCreators = "/platformAnalytics/top-creators";
export const PlatformAnalyticsSettlements = "/platformAnalytics/settlements";
export const PlatformAnalyticsCustomers = "/platformAnalytics/customers";
export const PlatformAnalyticsGrowth = "/platformAnalytics/growth";
export const PlatformAnalyticsMarketing = "/platformAnalytics/marketing";
export const PlatformAnalyticsTransactions = "/platformAnalytics/transactions";
export const PlatformAnalyticsCreatorDetail = "/platformAnalytics/creator";
export const PlatformAnalyticsNewRegistrations = "/platformAnalytics/new-registrations";
export const PlatformAnalyticsUsers = "/platformAnalytics/users";
export const PlatformAnalyticsUsersForIgUpdate = "/platformAnalytics/users-for-ig-update";
export const PlatformAnalyticsUpdateUserIgDetails = (userId) => "/platformAnalytics/users/" + userId + "/instagram-details";
export const PlatformAnalyticsInstagramIntegrationStats = "/platformAnalytics/instagram-integration-stats";
export const PlatformAnalyticsInstagramIntegrationDrilldown = "/platformAnalytics/instagram-integration/drilldown";

// SaaS plan adoption (BrandPage.plan)
export const PlatformAnalyticsSaasPlanStats = "/platformAnalytics/saas-plans/stats";
export const PlatformAnalyticsSaasPlanDrilldown = "/platformAnalytics/saas-plans/drilldown";
export const PlatformAnalyticsSaasPlanSearch = "/platformAnalytics/saas-plans/search";
export const PlatformAnalyticsSaasPlanGrantTrial = "/platformAnalytics/saas-plans/grant-trial";

// Instagram Automation plan adoption (ClientInstaAutomationsPlans)
export const PlatformAnalyticsInstaPlanStats = "/platformAnalytics/insta-plans/stats";
export const PlatformAnalyticsInstaPlanDrilldown = "/platformAnalytics/insta-plans/drilldown";

// Admin Leads
export const AdminLeads = "/admin-leads";
export const AdminLeadStats = "/admin-leads/stats";
// Per-lead funnel actions (Phase 4 surfaces)
export const AdminLeadResyncHubspot = (leadId) => `/admin-leads/${leadId}/resync-hubspot`;
export const AdminLeadOptOutNurture = (leadId) => `/admin-leads/${leadId}/opt-out-nurture`;
export const AdminLeadResumeNurture = (leadId) => `/admin-leads/${leadId}/resume-nurture`;
// v2 CRM — drawer endpoints (full join + stage transition audit)
export const AdminLeadFullProfile = (leadId) => `/admin-leads/${leadId}/full-profile`;
export const AdminLeadStageTransitions = (leadId) => `/admin-leads/${leadId}/stage-transitions`;
// CSV export of contacts matching a filter — same query params as AdminLeads
export const AdminLeadsExport = "/admin-leads/export";

// Admin CRM dashboard (funnel, conversion rates, revenue, ops health)
export const AdminCrmDashboard = "/admin-crm/dashboard";

// Admin Nurture (WhatsApp nurture sequence — programmatic msg91 template flow)
// v2: every per-step endpoint accepts an optional `sequenceKey` to scope writes
// to a specific sequence (prospect | qualified | onboarded | brand_page |
// event_created | first_sale | purchased_retention). Defaults to "prospect"
// on the backend for back-compat.
const seqQS = (sequenceKey) => (sequenceKey ? `?sequenceKey=${encodeURIComponent(sequenceKey)}` : "");

export const AdminNurtureTemplates = "/admin-nurture/templates"; // ?sequenceKey=X for filter
export const AdminNurtureTemplate = (stepDay, sequenceKey) => `/admin-nurture/templates/${stepDay}${seqQS(sequenceKey)}`;
// PATCH step-level config (UTM defaults, landingPath, isActive flag)
export const AdminNurtureTemplateConfig = (stepDay, sequenceKey) => `/admin-nurture/templates/${stepDay}/config${seqQS(sequenceKey)}`;
// PATCH the underlying WhatsAppTemplate body / buttonText / category
export const AdminNurtureTemplateBody = (stepDay, sequenceKey) => `/admin-nurture/templates/${stepDay}/body${seqQS(sequenceKey)}`;
// POST (multipart 'file') → upload a header image; DELETE → remove it
export const AdminNurtureTemplateHeaderMedia = (stepDay, sequenceKey) => `/admin-nurture/templates/${stepDay}/header-media${seqQS(sequenceKey)}`;
// Category images (per-(sequence, step) per-MainCategory) + imageMode toggle
export const AdminNurtureTemplateImages = (stepDay, sequenceKey) => `/admin-nurture/templates/${stepDay}/images${seqQS(sequenceKey)}`;
export const AdminNurtureTemplateImageMode = (stepDay, sequenceKey) => `/admin-nurture/templates/${stepDay}/image-mode${seqQS(sequenceKey)}`;
export const AdminNurtureTemplateImageUpload = (stepDay, mainCategory, sequenceKey) => `/admin-nurture/templates/${stepDay}/images/${mainCategory}${seqQS(sequenceKey)}`;
// POST → submit draft to msg91 for Meta approval
export const AdminNurtureTemplateSubmit = (stepDay, sequenceKey) => `/admin-nurture/templates/${stepDay}/submit${seqQS(sequenceKey)}`;
// POST → poll msg91 for current approval status
export const AdminNurtureTemplateSyncStatus = (stepDay, sequenceKey) => `/admin-nurture/templates/${stepDay}/sync-status${seqQS(sequenceKey)}`;
export const AdminNurtureTemplateTestSend = (stepDay, sequenceKey) => `/admin-nurture/templates/${stepDay}/test-send${seqQS(sequenceKey)}`;
export const AdminNurtureTemplateStats = (stepDay, sequenceKey) => `/admin-nurture/templates/${stepDay}/stats${seqQS(sequenceKey)}`;
// Aggregate funnel for /nurture/analytics — kpis + funnel + perStep + perCategory in one shot
export const AdminNurtureFunnel = (sequenceKey, window) => {
  const qs = new URLSearchParams();
  if (sequenceKey) qs.set("sequenceKey", sequenceKey);
  if (window) qs.set("window", window);
  const s = qs.toString();
  return `/admin-nurture/funnel${s ? `?${s}` : ""}`;
};
// Drill-down: list of contacts in a specific bucket
export const AdminNurtureFunnelContacts = (sequenceKey, window, bucket) => {
  const qs = new URLSearchParams();
  if (sequenceKey) qs.set("sequenceKey", sequenceKey);
  if (window) qs.set("window", window);
  if (bucket) qs.set("bucket", bucket);
  return `/admin-nurture/funnel/contacts?${qs.toString()}`;
};
export const AdminNurtureFunnelRetryFailed = "/admin-nurture/funnel/retry-failed";
export const AdminNurtureMessages = "/admin-nurture/messages";
export const AdminNurtureQueueState = "/admin-nurture/queue/state";
export const AdminNurtureQueuePause = "/admin-nurture/queue/pause";
export const AdminNurtureQueueResume = "/admin-nurture/queue/resume";

// SEO Blogs
export const SEOBlogsBase = "/seo-blogs";

// Founder Goals
export const AdminGoalsList = "/admin-goals";
export const AdminGoalById = (id) => `/admin-goals/${id}`;
export const AdminGoalProgress = (id) => `/admin-goals/${id}/progress`;
export const AdminGoalActiveProgress = "/admin-goals/active/progress";

// Platform Settings (admin-editable runtime config)
export const PlatformSettings = "/platform-settings";

// Plan-expiry WhatsApp renewal reminders (ops endpoints)
export const PlanExpiryRunSweep = "/admin-nurture/plan-expiry/run-sweep";
export const PlanExpiryTestSend = "/admin-nurture/plan-expiry/test-send";
export const PlanExpiryStats = "/admin-nurture/plan-expiry/stats";
export const PlanExpiryPostBlast = "/admin-nurture/plan-expiry/post-expiry-blast";
